export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
    const investmentButtons = document.querySelectorAll('.investment-selection');

    const investmentButtonAction = (e, target) => {
      e.preventDefault();

      document.querySelector(`#${target}`).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }

    investmentButtons.forEach(
      (investmentButton) => {
        investmentButton.addEventListener('click', (e) => { investmentButtonAction(e, investmentButton.dataset.target) }, false);
      }
    );
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/wealth-creation.js